import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=9b87afe8&scoped=true&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=9b87afe8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87afe8",
  null
  
)

export default component.exports